import { AnimatePresence, m } from "framer-motion";
import React from "react";
import { useRouter } from "next/router";
import { useScrollRestore } from "~/features/ui/use-scroll-restore";
import { PAGE_SLUGS } from "~/features/craft/constants";
import { clearRouterPath } from "~/features/app/utils";
import { useLocale } from "~/features/i18n/use-locale";
export const TRANSITION_DURATION = 0.4;
type Props = {
  children: React.ReactNode;
};
export function PageTransition(props: Props) {
  const {
    children
  } = props;
  const router = useRouter();
  const locale = useLocale();
  const restoreScrollPosition = useScrollRestore(Object.values(PAGE_SLUGS).map(slug => `/${slug}`));
  return <AnimatePresence initial={false} mode="wait" onExitComplete={restoreScrollPosition}>
      <m.div key={`${clearRouterPath(router.asPath)}-${locale}`} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      ease: "easeInOut",
      duration: TRANSITION_DURATION
    }} id="transition-container">
        {/* Don't propagate initial={false} to children https://github.com/framer/motion/issues/724 */}
        <AnimatePresence initial={true}>
          <React.Fragment>{children}</React.Fragment>
        </AnimatePresence>
      </m.div>
    </AnimatePresence>;
}